// @flow
import LIUtils from "../GUI_COMMON/SUPPORT/LIUtils";

class ArchiverUtils {
    
    static BOX_BARCODE_VALIDATION_REGEX:string="^(\\d{1,2})([a-zA-Z]*[+-]?).(\\d{4})$";
    
    /**
     * given an array buffer, return it as a base64 encoded string
     * suitable for transport across the wire.
     * @param buffer
     * @returns {string}
     * @constructor
     */
    static Base64EncodeArrayBuffer(buffer:ArrayBuffer):string {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return btoa(binary);
    }
    
    static BoxRangesAreOk(boxRangeValue):boolean {
        if (boxRangeValue.length === 0) return false;  // empty

        const parts = boxRangeValue.trim().split("-");
        if (parts.length > 2) return false;  // more than 2 parts

        const box1 = parts[0].trim();
        if (LIUtils.boxBarcodeHasGoodFormat(box1) === false) return false; // bad format
        if (parts.length === 2) {
            const box2 = parts[1].trim();
            if (LIUtils.boxBarcodeHasGoodFormat(box2) === false) return false; // bad format

            // we need to make sure they are from the same pneumonic
            const re = new RegExp(ArchiverUtils.BOX_BARCODE_VALIDATION_REGEX);
            const m1 = re.exec(box1);
            const m2 = re.exec(box2);

            const year1 = m1[1];
            const pneumonic1 = m1[2];
            const boxNumber1 = m1[3];

            const year2 = m2[1];
            const pneumonic2 = m2[2];
            const boxNumber2 = m2[3];

            if (year1 > year2 || pneumonic1 !== pneumonic2) return false; // year is out of order, or pnuemonics don't match
            if (year1 === year2 && boxNumber1 > boxNumber2) return false; // box number is out of order
        }
        return true; // all good
    }

    /**
     * prepare an array of box and child mag ids from the boxesAndChildMags object
     * 
     * @param boxesAndChildMags
     * @returns {[*|*[],[]]}
     * @constructor
     */
    static SeperateBoxesAndChildMags(boxesAndChildMags):[number[],number[]] {
        const completeBoxIdList = boxesAndChildMags?.map(item => item.box.id)??[];
        let completeMagIdList = [];
        for(let boxIndex = 0; boxIndex < completeBoxIdList.length; boxIndex++) {
            const thisBoxMags = boxesAndChildMags[boxIndex]?.childMags?.map(mag => mag.id)??[];
            completeMagIdList = completeMagIdList.concat(thisBoxMags);
        }
        
        return [completeBoxIdList,completeMagIdList];
    }

    /**
     * helper to determine if the given box range should generate a warning
     * to the user about being fairly large
     * @param boxRange
     * @returns {boolean}
     * @constructor
     */
    static CheckBoxRangeForWarning(boxRange) {

        // take the box range apart
        const boxRangeParts = boxRange.split("-");
        if (boxRangeParts.length !== 2) { // only a single box here -- fine
            return false;
        }
        const firstBox = boxRangeParts[0];
        const firstBoxParts = firstBox.split(".");
        if (firstBoxParts.length !== 2) { // bad range -- ignore (server will take care of it)
            return false;
        }
        const lastBox = boxRangeParts[1];
        const lastBoxParts = lastBox.split(".");
        if (lastBoxParts.length !== 2) { // bad range -- ignore (server will take care of it)
            return false;
        }
        if(firstBoxParts[0] < lastBoxParts[0]) { // at least 1 year here -- warn
            return true;
        }

        const range = Number(lastBoxParts[1]) - Number(firstBoxParts[1]);
        return range > 100; // more than 100 boxes is a warning
    }
}

export default ArchiverUtils;